import React, { useEffect, useState } from 'react';
import styles from './PWAInstallTutorial.module.scss';
import HomeScreenTutorialScreenFigure from '@assets/homescreentutorialscreenfigure.png';
import HomeScreenTutorialScreenStep2Figure from '@assets/homescreentutorialstep2figure.png';
import HomeScreenTutorialScreenStep2FirefoxFigure from '@assets/homescreentutorialstep2figureFirefox.png';
import HomeScreenTutorialScreenStep2SafariFigure from '@assets/homescreentutorialstep2figureSafari.png';
import HomeScreenTutorialScreenStep3Figure from '@assets/homescreentutorialstep3figure.png';
import HomeScreenTutorialScreenStep3AlternateFigure from '@assets/homescreentutorialstep3alternatefigure.png';
import HomeScreenTutorialScreenStep3AlternateFigureSafari from '@assets/homescreentutorialstep3alternatefiguresafari.png';
import HomeScreenTutorialScreenStep4Figure from '@assets/homescreentutorialstep4figure.png';
import HomeScreenTutorialScreenStep5Figure from '@assets/homescreentutorialstep5figure.png';
import HomeScreenTutorialScreenStep5FigureSafari from '@assets/homescreentutorialstep5figureSafari.png';
import { Typography } from '@material-ui/core';
import JetButton from '../JetButton';
import * as Bowser from 'bowser';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon';
import utilStorage from '@shared/services/util-storage';
import { useTranslation } from 'react-i18next';
import useBannerTracking from '@src/shared/hooks/use-banner-tracking';
import { waitInMilliseconds } from '@src/shared/utils';
export const PWAInstallTutorial = ({ onPostPone = () => {}, messageScreenStatus = null }) => {
  const { t } = useTranslation();
  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  const browserOS = browser.getOSName();
  const browserPlatform = browser.getPlatformType();
  const startStep = messageScreenStatus === null ? 1 : 2;
  const [step, setStep] = useState(startStep);
  const [showTutorial, setShowTutorial] = useState(false);
  const { trackBannerView, trackBannerSelect } = useBannerTracking('pwa info');

  const onPostPoneClicked = () => {
    utilStorage.setPWATutorialLater();
    setShowTutorial(false);
    onPostPone();
  };

  const isValidBrowser = () => {
    return (
      (browserPlatform === Bowser.PLATFORMS_MAP.mobile &&
        browserName === Bowser.BROWSER_MAP.chrome &&
        browserOS === Bowser.OS_MAP.Android) ||
      (browserName === Bowser.BROWSER_MAP.firefox && browserOS === Bowser.OS_MAP.Android) ||
      (browserName === Bowser.BROWSER_MAP.edge && browserOS === Bowser.OS_MAP.Android) ||
      (browserName === Bowser.BROWSER_MAP.safari && browserOS === Bowser.OS_MAP.iOS)
    );
  };

  useEffect(() => {
    const postpone = utilStorage.getPWATutorialPostpone();

    if (isValidBrowser() && !postpone) {
      setShowTutorial(true);
      if (startStep !== 2) {
        (async () => {
          await waitInMilliseconds(30000);
          trackBannerView();
        })();
      }
    }
  }, []);

  const renderStepCTAButton = () => {
    const totalStepConfig = {
      [Bowser.BROWSER_MAP.edge]: 5,
      [Bowser.BROWSER_MAP.chrome]: 5,
      [Bowser.BROWSER_MAP.firefox]: 5,
      [Bowser.BROWSER_MAP.safari]: 4,
    };
    const totalStep = totalStepConfig[browserName] || 0;
    const text =
      step !== totalStep
        ? t('pwa_installation_screen.steps_next_button')
        : t('pwa_installation_screen.steps_close_button');
    const onClickHandler = () => {
      if (step === totalStep) {
        onPostPoneClicked();
      } else {
        setStep(step + 1);
      }
    };
    return (
      <JetButton variation="primary" size="small" onClick={onClickHandler}>
        {text}
      </JetButton>
    );
  };

  return (
    (showTutorial && (
      <div
        className={`${messageScreenStatus === false ? '' : styles.delayedShow} ${
          styles.pwaTutorialContainer
        } ${step > 1 ? styles.isNotFirstStep : ''} `}
      >
        <div className={styles.pwaTutorialInnerContainer}>
          <div className="closecontainer">
            <JetFontIcon
              iconname={JET_FONTICON_ALIASES.CLOSE}
              onClick={() => onPostPoneClicked()}
              size={14}
              className={styles.closebutton}
            />
          </div>
          {step === 1 && (
            <div className={styles.step1}>
              <img className={styles.pwaStep1Image} src={HomeScreenTutorialScreenFigure} />

              <Typography
                variant="body1"
                className={`body_bold ${styles.stepTitle}`}
                align="center"
              >
                {t('pwa_installation_screen.initial_message_title')}
              </Typography>
              <Typography
                variant="body1"
                className={`body_regular ${styles.stepDescription}`}
                align="left"
              >
                {t('pwa_installation_screen.initial_message_description')}
              </Typography>
              <div className={styles.buttonContainer}>
                <JetButton
                  variation="ghost"
                  size="small"
                  className={styles.laterbtn}
                  onClick={() => onPostPoneClicked()}
                >
                  {t('pwa_installation_screen.initial_message_cta1')}
                </JetButton>
                <JetButton
                  variation="primary"
                  size="small"
                  className={styles.yesbtn}
                  onClick={() => {
                    trackBannerSelect();
                    setStep(2);
                  }}
                >
                  {t('pwa_installation_screen.initial_message_cta2')}
                </JetButton>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className={styles.step2}>
              <div className={styles.imageContainer}>
                {(browserName === Bowser.BROWSER_MAP.chrome ||
                  browserName === Bowser.BROWSER_MAP.edge) && (
                  <img className={styles.pwaStep2Image} src={HomeScreenTutorialScreenStep2Figure} />
                )}
                {browserName === Bowser.BROWSER_MAP.firefox && (
                  <img
                    className={styles.pwaStep2Image}
                    src={HomeScreenTutorialScreenStep2FirefoxFigure}
                  />
                )}
                {browserName === Bowser.BROWSER_MAP.safari && (
                  <img
                    className={styles.pwaStep2Image}
                    src={HomeScreenTutorialScreenStep2SafariFigure}
                  />
                )}
              </div>
              <Typography variant="h4" className={`heading_m ${styles.stepTitle}`} align="center">
                {t('pwa_installation_screen.step1_title')}
              </Typography>
              <Typography
                variant="body1"
                className={`body_regular ${styles.stepDescription}`}
                align="center"
              >
                {browserName === Bowser.BROWSER_MAP.chrome &&
                  t('pwa_installation_screen.step1_content_chrome')}
                {browserName === Bowser.BROWSER_MAP.firefox &&
                  t('pwa_installation_screen.step1_content_firefox')}
                {browserName === Bowser.BROWSER_MAP.safari &&
                  t('pwa_installation_screen.step1_content_safari')}
                {browserName === Bowser.BROWSER_MAP.edge &&
                  t('pwa_installation_screen.step1_content_edge')}
              </Typography>
              {renderStepCTAButton()}
            </div>
          )}

          {step === 3 && (
            <div className={styles.step3}>
              <div className={styles.imageContainer}>
                {(browserName === Bowser.BROWSER_MAP.chrome ||
                  browserName === Bowser.BROWSER_MAP.edge) && (
                  <img className={styles.pwaStep3Image} src={HomeScreenTutorialScreenStep3Figure} />
                )}
                {browserName === Bowser.BROWSER_MAP.firefox && (
                  <img
                    className={styles.pwaStep3Image}
                    src={HomeScreenTutorialScreenStep3AlternateFigure}
                  />
                )}
                {browserName === Bowser.BROWSER_MAP.safari && (
                  <img
                    className={styles.pwaStep3Image}
                    src={HomeScreenTutorialScreenStep3AlternateFigureSafari}
                  />
                )}
              </div>
              <Typography variant="h4" className={`heading_m ${styles.stepTitle}`} align="center">
                {t('pwa_installation_screen.step2_title')}
              </Typography>
              <Typography
                variant="body1"
                className={`body_regular ${styles.stepDescription}`}
                align="center"
              >
                {browserName === Bowser.BROWSER_MAP.chrome &&
                  t('pwa_installation_screen.step2_content_chrome')}
                {browserName === Bowser.BROWSER_MAP.edge &&
                  t('pwa_installation_screen.step2_content_edge')}
                {browserName === Bowser.BROWSER_MAP.firefox &&
                  t('pwa_installation_screen.step2_content_firefox')}
                {browserName === Bowser.BROWSER_MAP.safari &&
                  t('pwa_installation_screen.step2_content_safari')}
              </Typography>
              {renderStepCTAButton()}
            </div>
          )}

          {step === 4 && (
            <div className={styles.step4}>
              <div className={styles.imageContainer}>
                {browserName !== Bowser.BROWSER_MAP.safari && (
                  <img className={styles.pwaStep4Image} src={HomeScreenTutorialScreenStep4Figure} />
                )}
                {browserName === Bowser.BROWSER_MAP.safari && (
                  <img
                    className={styles.pwaStep4Image}
                    src={HomeScreenTutorialScreenStep5FigureSafari}
                  />
                )}
              </div>
              <Typography variant="h4" className={`heading_m ${styles.stepTitle}`} align="center">
                {t('pwa_installation_screen.step3_title')}
              </Typography>
              <Typography
                variant="body1"
                className={`body_regular ${styles.stepDescription}`}
                align="center"
              >
                {browserName === Bowser.BROWSER_MAP.safari &&
                  t('pwa_installation_screen.step3_content_safari')}
                {browserName !== Bowser.BROWSER_MAP.safari &&
                  t('pwa_installation_screen.step3_content_not_safari')}
              </Typography>
              {renderStepCTAButton()}
            </div>
          )}

          {step === 5 && (
            <div className={styles.step5}>
              <div className={styles.imageContainer}>
                <img className={styles.pwaStep5Image} src={HomeScreenTutorialScreenStep5Figure} />
              </div>
              <Typography variant="h4" className={`heading_m ${styles.stepTitle}`} align="center">
                {t('pwa_installation_screen.step4_title')}
              </Typography>
              <Typography
                variant="body1"
                className={`body_regular ${styles.stepDescription}`}
                align="center"
              >
                {t('pwa_installation_screen.step4_content')}
              </Typography>
              {renderStepCTAButton()}
            </div>
          )}
        </div>
      </div>
    )) || <></>
  );
};
